import { IArrangementProduct, IProductObject } from '@features/categories/typescript';
import { IParsedImage, IVideoPimResponsive, TImage } from '@components/typescript';
class ArrangementProductState {
  public id: number;
  public name: string;
  public image: TImage;
  public imageWithBlur: IParsedImage;
  public video: IVideoPimResponsive;
  public products: IProductObject[];
  public productsUrl: string;
  public productsCount: number;
  constructor(product: IArrangementProduct) {
    this.id = product.id;
    this.name = product.name;
    this.image = product.image;
    this.imageWithBlur = product.imageWithBlur;
    this.video = product.video;
    this.products = [];
    this.productsUrl = product.products_url;
    this.productsCount = product.products_count;
  }
}
export default ArrangementProductState;